<ngx-spinner bdColor = "rgba(0, 0, 0, 0.5)" (dblclick)="routelink1('/');"
size = "small" color = "rgb(0, 0, 0,0.01)" [fullScreen] = "true">

<div class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
<span style="color:#fff ;" >Loading</span>
</div>

</ngx-spinner>
<header id="header" class="header">
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" href="#"
        ><img alt="TamilNadu" src="https://tnurbanepay.tn.gov.in/UTIS/assets/images/logo.svg"
      /></a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <div class="logo">
          <img alt="menu"
            src="https://tnurbanepay.tn.gov.in/UTIS/assets/images/Hamburger_icon.svg.png"
            width="25"
          />
        </div>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item mobile-none">
            <h1>{{ headerTitle }}</h1>
            
          </li>
        </ul>

        <ul class="navbar-nav  mb-2 mb-lg-0">
          <li class="nav-item">
            <span class="userinfo-details"
              ><strong>{{ userName }}</strong> </span
            ><br />
            <div class="userinfo-details">
              <strong>{{ (UserDesc === 'null'?'':UserDesc) | titlecase  }}</strong> 
            </div>
            <span class="userinfo-details">{{
              loginTimeStamp | date: "dd/MMM/yyyy hh:mm:ss"
            }}</span>
          </li>
        </ul>
        <ul class="navbar-nav">
          <li *ngIf="(Usertyp == 'CMA')" class="nav-item1 p-4" title="Go To Home">
            

            <svg (click)="routelink('/');" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-house" viewBox="0 0 16 16">
              <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
            </svg>

          </li>
          <li *ngIf="(Usertyp == 'DTP')" class="nav-item1 p-4" title="Go To Home">
            <!-- <img alt="Home"
              style="width: 75px"
              class="nav-btn"
              src="https://tnurbanepay.tn.gov.in/UTIS/assets/images/home.svg"
             
              (click)="routelink('/');"
            /> -->
            
            <svg (click)="routelink('/');" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-house" viewBox="0 0 16 16">
              <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
            </svg>
          </li>
          <li *ngIf="(Usertyp == 'MAWS')" class="nav-item1 p-4" title="Go To Home">
            <!-- <img alt="Home"
              style="width: 75px"
              class="nav-btn"
              src="https://tnurbanepay.tn.gov.in/UTIS/assets/images/home.svg"
             
              (click)="routelink('/');"
            /> -->
            
            <svg (click)="routelink('/');" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-house" viewBox="0 0 16 16">
              <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
            </svg>
          </li>
          
            <li *ngIf="Usertyp === 'MAWS'" class="nav-item1 p-4" (click)="goBack()" title="Go Back">
              
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-reply-fill" viewBox="0 0 16 16">
                <path d="M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"/>
              </svg>

            </li> 
         
            <li class="nav-logout p-4" (click)="signOut()" title="Click to Log out">
              <!-- <img alt="Logout"
                style="width: 74px"
                class="nav-btn"
                src="https://tnurbanepay.tn.gov.in/UTIS/assets/images/logout.svg"
              /> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-box-arrow-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/>
                <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
              </svg>
            </li>
            <li class="nav-item1 p-4" (click)="openFullscreen()" title="FullScreen Mode">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-fullscreen" viewBox="0 0 16 16">
                <path d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z"/>
              </svg>
            </li>
          </ul>
      </div>
    </div>
  </nav>
</header>
